/**
 * Copyright 2025 Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { LanguageService } from "../../i18n/language.service";
import { IActionHandlerInterceptor } from "sirius-platform-support-library/shared/actions/interceptors/action-handler-interceptor.interface";
import {
  Action,
  ActionTypeEnum,
} from "sirius-platform-support-library/models/common";
import { ActionMetadata } from "sirius-platform-support-library/shared/actions/action-metadata";
import { environment } from "../../../../environments/environments";
export const UserNavigationInterceptorTypeName =
  "UserNavigationInterceptorTypeName";

export class UserNavigationInterceptor implements IActionHandlerInterceptor {
  languageService: LanguageService;
  sctHost: string;

  public constructor(languageService: LanguageService) {
    this.languageService = languageService;
    this.sctHost = environment.sctHost;
  }

  intercept(
    context: any,
    source: string,
    action: Action,
    metadata?: ActionMetadata,
    fireActionPerformedEvent?: boolean
  ): Promise<boolean | undefined> {
    // only act on actions that navigate the user to SCT
    if (action.type === ActionTypeEnum.URL && this.isSctUrl(action.action)) {
      const url = new URL(action.action);
      const params = url.searchParams;
      params.set("lang", this.languageService.getLocale());
      action.action = url.toString();
    }
    return undefined;
  }

  private isSctUrl(url: string): boolean {
    try {
      // check that this is a full URL
      const fullUrl = new URL(url);
      // check that it is to SCT (we don't set language params to other websites)
      return fullUrl.host === this.sctHost;
    } catch (err) {
      return false;
    }
  }
}
